<template>
    <div>
        <Chat ref="chat" view="chat" homeUrl="https://www.jourhavande-medmanniska.se">
            <template v-slot:header>
                <header class="chat__header">
                    <a class="chat__header__logo" href="https://www.jourhavande-medmanniska.se">
                        <img src="@/assets/logo.svg" title="Jourhavande Medmanniska" />
                    </a>
                    <h1 class="chat__header__title">
                        <span>Jourhavande Medmanniska - chatt</span>
                        <svg v-on:click="leave" class="chat__header__close" xmlns="http://www.w3.org/2000/svg" height="40px" width="40px" viewBox="0 -960 960 960" fill="currentColor"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>
                    </h1>
                </header>
            </template>

            <template v-slot:card="{ status, texts, start, goto }">
                <div class="chat__card">
                    <div v-if="status == 'open'">
                        <h2 class="chat__card__title">Välkommen!</h2>
                        <br />
                        <p v-if="texts.status" v-html="texts.status" class="chat__card__text"></p>
                        <button v-on:click="start" class="button chat__card__button">Starta chatta</button>
                        <br />
                        <br />
                    </div>
                    <div v-else-if="status == 'queue'">
                        <button v-on:click="goto" class="button button--disabled">Gå till chatten</button>
                        <br />
                        <br />
                    </div>
                    <div v-else-if="status == 'chat'">
                        <button v-on:click="goto" class="button button--disabled">Gå till chatten</button>
                        <br />
                        <br />
                    </div>
                    <div v-else-if="status == 'max_queue'">
                        <button class="button button--disabled">Chatten är just nu full</button>
                        <br />
                        <br />
                    </div>
                    <div v-else-if="status == 'close_queue'">
                        <button class="button button--disabled">Kön är nu stängd</button>
                        <br />
                        <br />
                    </div>
                    <div v-else>
                        <button class="button button--disabled">Chatten är stängd</button>
                    </div>
                    <div v-if="texts.openinghours" class="card__openinghours">
                        <span v-html="texts.openinghours"></span>
                    </div>
                </div>
            </template>

            <template v-slot:queue="{ queue }">
                <div class="chat__queue" v-if="queue.alert">
                    <h2 class="chat__queue__title">Chatten är stängd</h2>
                    <p class="chat__queue__text" v-html="queue.alert"></p>
                </div>
                <div class="chat__queue" v-else-if="queue.invite">
                    <p class="chat__queue__text" v-html="queue.invite"></p>
                </div>
                <div class="chat__queue" v-else>
                    <h2 class="chat__queue__title">Välkommen!</h2>
                    <p class="chat__queue__text">
                        Vi chattar med dig så fort vi kan.<br />
                        Tack för att du väntar!<br />
                        <br />
                    </p>
                    <p class="chat__queue__position" v-if="queue.position == '0'">
                        Du är först i kön.
                    </p>
                    <p class="chat__queue__position" v-else>Du är nummer {{ queue.position }} i kön</p>
                    <div class="chat__queue__pulse">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </template>

            <template v-slot:typing="{ typing, volunteer }">
                <div class="chat__typing">
                    <template v-if="typing">{{ volunteer ? volunteer : 'Volontär' }} skriver...</template>
                </div>
            </template>
        </Chat>
    </div>
</template>

<script>
import Chat from '@/../../chat/client/src/components/Chat.vue';

export default {
    components: {
        Chat,
    },
    methods: {

        /**
         * leave
         */
        leave: function(e) {
            this.$refs.chat.leave(e);
        },

    },
};
</script>

<style lang="scss">
@import './../styles/global';

body.chat {
    background-color: $body-background-color;
}

div.chat {
    max-width: $chat-width;
    margin: 0 auto;

    background-color: #fff;
    border:1px solid #221f20;
}

.chat__header {
    height: 90px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    width: 100%;

    background-color: #221f20;

    &__logo {
        margin:10px 30px;
        width: 140px;

        img {
            display: block;
            max-width: 100%;
        }
    }

    &__title {
        margin-right: 30px;
        display: flex;
        align-items: center;
        justify-content: center;

        span {
            display: none;
        }
        img {
            display: none;
            width: 40px;
            height: 40px;

            @media only screen and (min-width: 860px) {
                display: block;
            }
        }

        svg {
            display: block;
            color:#000;
            @media only screen and (min-width: 860px) {
                display: none;
            }
        }
    }
}

.chat__nav {
    display: flex;
    justify-content: space-between;
    margin: 10px 20px 0 20px;
    padding-bottom: 8px;
    border-bottom: 1px solid #ddd;

    &__volunteer {
    }
    &__privacy-policy {
    }
}

.chat:has(.chat__queue__more) {
    position: static;
}

.chat__queue {
    &__title {
        margin-top: 10px;
        margin-bottom: 40px;
        font-size: 28px;
    }

    &__text {
        width: 80%;
        margin: 0 auto;
    }

    &__more {
        width: 80%;
        margin: 0 auto;
    }
}

.chat__actions {
    border-top:1px solid #221f20;
}

.chat__buttons {
    .button {
        &:focus {
            text-decoration: underline;
        }
    }
}

.dialog {
    @media only screen and (min-width: 720px) {
        &--large {
            min-width: 720px;
        }
    }
}

</style>
